exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app[_v-6f58f7a2]{margin:20px auto;width:800px;height:600px;overflow:hidden;border-radius:3px}#app .main[_v-6f58f7a2],#app .sidebar[_v-6f58f7a2]{height:100%}#app .sidebar[_v-6f58f7a2]{float:left;width:200px;color:#f4f4f4;background-color:#2e3238}#app .main[_v-6f58f7a2]{position:relative;overflow:hidden;background-color:#eee}#app .text[_v-6f58f7a2]{position:absolute;width:100%;bottom:0;left:0}#app .message[_v-6f58f7a2]{height:calc(100% - 160px)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6f58f7a2&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/App.vue
 ** module id = 302
 ** module chunks = 0
 **/